import { CustomDateFormatPipe } from '../../../../../_helpers/_pipes/custom-date-format.pipe';
import { ArrorRightSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/arror-right-svg/arror-right-svg.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule, ArrorRightSvgComponent, CustomDateFormatPipe],
  selector: 'app-claims-home-car',
  templateUrl: './claims-home-car.component.html',
})
export class ClaimsHomeCarComponent implements OnInit {
  @Input() claim;
  @Input() claimid;
  @Input() exposure;
  @Input() type = 'header';
  isAcmic: boolean;

  constructor(private acmicService: AcmicService) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();    
  }
}
